/*
 * Copyright © Siemens 2026
 */

import { Component, computed, inject, OnInit } from '@angular/core';
import { RouterOutlet, RouterLink, Router } from '@angular/router';
import {
    IxApplication, IxApplicationHeader, IxAvatar,
    IxMenu, IxMenuItem, IxTypography, IxDropdownItem
} from '@siemens/ix-angular/standalone';
import { addIcons } from '@siemens/ix-icons';
import {
  iconUpload, iconLogOut, iconLogIn, iconKey, iconError, iconTrashcan, iconTree,
  iconChevronLeft, iconChevronRight, iconInfo, iconList, iconApplications,
  iconUserLock, iconSearch, iconClear, iconAddCircle, iconSuccess, iconHome, iconDownload, iconMoreMenu,
  iconTreeTwoLevel, iconDocument, iconUserGroup, iconUserKey
} from '@siemens/ix-icons/icons';

import Logo from '../assets/images/logo/logo';
import { UserService } from './core/auth/services/user.service';
import { AuthService } from './core/auth/services/auth.service';
import { LogoutModal } from './components/logout-modal/logout-modal';
import { BreadcrumbComponent } from './shared/components/breadcrumb/breadcrumb';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    RouterLink,
    IxApplication,
    IxApplicationHeader,
    IxMenu,
    IxMenuItem,
    IxAvatar,
    IxTypography,
    IxDropdownItem,
    Logo,
    LogoutModal,
    BreadcrumbComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'publisher-ui';

  userService = inject(UserService);
  private authService = inject(AuthService);
  private router = inject(Router);

  readonly isManagerOrAdmin = computed(() =>
    this.userService.hasAnyRole(['MANAGER', 'ADMIN'])
  );

  ngOnInit(): void {
    addIcons({
      iconUpload, iconLogOut, iconLogIn, iconKey, iconError, iconDownload,
      iconTrashcan, iconTree, iconChevronLeft, iconChevronRight,
      iconInfo, iconList, iconApplications, iconUserLock,
       iconSearch, iconClear, iconAddCircle, iconSuccess, iconHome, iconMoreMenu,
       iconTreeTwoLevel, iconDocument, iconUserGroup, iconUserKey
    });
  }

  isActivePage(route: string): boolean {
    const firstSegment = this.router.url.split('/')[1];
    return firstSegment === route;
  }

  get userName(): string | undefined {
    return this.userService.userName();
  }

  login(): void {
    this.authService.login();
  }

  logout(): void {
    this.authService.logout();
  }
}
